import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoginService } from '../login.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
  standalone: false
})
export class AccessDeniedComponent {
  constructor(
    public ls: LoginService,
    private http: HttpClient,
    private translate: TranslateService
  ) {}

  // Label of the clinical system the user came from (mirrors BarComponent.getButtonText).
  getButtonText(): string {
    if (this.ls.isCardio) return this.translate.instant('appointments.gui.labels.domains.Cardio');
    if (this.ls.isGastro) return this.translate.instant('appointments.gui.labels.domains.Gastro');
    if (this.ls.isEyes) return this.translate.instant('appointments.gui.labels.domains.Eyes');
    if (this.ls.isUSG) return this.translate.instant('appointments.gui.labels.domains.USG');
    if (this.ls.isObgyn) return this.translate.instant('appointments.gui.labels.domains.OBGYN');
    return '';
  }

  // Seamless jump back to the clinical system the user arrived from.
  redirectAdministration() {
    const type = this.ls.isCardio ? 'cardio'
      : this.ls.isGastro ? 'gastro'
      : this.ls.isEyes ? 'eyes'
      : this.ls.isUSG ? 'usg'
      : 'aweb';
    this.http.post('/api/administration', { type }).subscribe((data: string) => {
      window.location.href = data;
    });
  }
}
